"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2754],{

/***/ 82754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47170);

/* harmony default export */ __webpack_exports__["default"] = (framer_motion__WEBPACK_IMPORTED_MODULE_0__/* .domMax */ .g);


/***/ })

}]);